import { createModule } from '../../createModule';
import { buildFilesFormData, parseInput } from '../../shared';
import * as AttributionsSchemas from './attributions.schemas';
export const createAttributionsAPI = createModule(({ http }) => {
    return {
        dataPresence: {
            getProcessState: async () => {
                const res = await http.get('/v2/attributions/process-state');
                return res;
            },
            getBanksAttributions: async () => {
                const res = await http.get('/v2/attributions/data-presence/banks-attributions');
                return res;
            },
            getOpsAttributions: async () => {
                const res = await http.get('/v2/attributions/data-presence/ops-attributions');
                return res;
            },
            uploadOpsAttributions: async (body) => {
                const params = parseInput(AttributionsSchemas.uploadFilesSchema, body);
                const res = await http.post('/v2/attributions/data-presence/ops-attributions/upload', { body: buildFilesFormData('files', params.files) });
                return res;
            },
            uploadOpsSchedules: async (body) => {
                const params = parseInput(AttributionsSchemas.uploadFilesSchema, body);
                const res = await http.post('/v2/attributions/data-presence/ops-schedules/upload', { body: buildFilesFormData('files', params.files) });
                return res;
            },
            uploadJPMValuations: async (body) => {
                const params = parseInput(AttributionsSchemas.uploadFilesSchema, body);
                const res = await http.post('/v2/attributions/data-presence/jpm-valuations/upload', { body: buildFilesFormData('files', params.files) });
                return res;
            },
            runBanksExtracts: async (body) => {
                const params = parseInput(AttributionsSchemas.runDataExtractSchema, body);
                const res = await http.post('/v2/attributions/data-presence/extract/banks', {
                    body: params,
                });
                return res;
            },
            runCustodiansExtracts: async (body) => {
                const params = parseInput(AttributionsSchemas.runDataExtractSchema, body);
                const res = await http.post('/v2/attributions/data-presence/extract/custodians', {
                    body: params,
                });
                return res;
            },
        },
        riskPremia: {
            getPNLdiscrepancies: async (params) => {
                const res = await http.get('/v2/attributions/risk-premia/pnl-discrepancies', {
                    params,
                });
                return res;
            },
            updatePNLDiscrepancy: async (body) => {
                const params = parseInput(AttributionsSchemas.updatePNLDiscrepancySchema, body);
                const res = await http.patch('/v2/attributions/risk-premia/pnl-discrepancy', {
                    body: params,
                });
                return res;
            },
            getSecuritiesdiscrepancies: async (params) => {
                const res = await http.get('/v2/attributions/risk-premia/securities-discrepancies', { params });
                return res;
            },
            getFinalAttributions: async (params) => {
                const res = await http.get('/v2/attributions/risk-premia/final-attributions', {
                    params,
                });
                return res;
            },
            getChart: async (params) => {
                const res = await http.get('/v2/attributions/risk-premia/chart', { params });
                return res;
            },
            runRiskPremia: async (body) => {
                const params = parseInput(AttributionsSchemas.discrepanciesParamsSchema, body);
                const res = await http.post('/v2/attributions/risk-premia/run', { body: params });
                return res;
            },
            validateFinalAttributions: async (body) => {
                const params = parseInput(AttributionsSchemas.discrepanciesParamsSchema, body);
                const res = await http.post('/v2/attributions/risk-premia/final-attributions', {
                    body: params,
                });
                return res;
            },
        },
        fixedIncome: {
            getState: async () => {
                const res = await http.get('/v2/attributions/fixed-income/state');
                return res;
            },
            getFinalAttributions: async (params) => {
                const res = await http.get('/v2/attributions/fixed-income/final-attributions', { params });
                return res;
            },
            run: async (body) => {
                const params = parseInput(AttributionsSchemas.runFixedIncomeSchema, body);
                const res = await http.post('/v2/attributions/fixed-income/run', { body: params });
                return res;
            },
            sendEmail: async (body) => {
                const params = parseInput(AttributionsSchemas.sendFixedIncomeEmailSchema, body);
                const res = await http.post('/v2/attributions/fixed-income/email', { body: params });
                return res;
            },
        },
        modelComparison: {
            getData: async (params) => {
                const res = await http.get('/v2/attributions/model-comparison/data', { params });
                return res;
            },
            getChart: async (params) => {
                const res = await http.get('/v2/attributions/model-comparison/chart', { params });
                return res;
            },
        },
    };
});
